/* ============================================================
   new-nav.js — Scrollable Navigation Bar Logic | Amazon
   (loaded with defer; null-safe; resize is debounced)
   ============================================================ */

(function () {
  function initNewNav() {
    var wrapper = document.querySelector('.new-wrapper');
    var view    = document.querySelector('.new-view');
    var list    = document.querySelector('.new-list');
    var btnPrev = document.querySelector('.new-prev');
    var btnNext = document.querySelector('.new-next');

    if (!wrapper || !view || !list || !btnPrev || !btnNext) return;
    if (wrapper.dataset.newNavReady) return;
    wrapper.dataset.newNavReady = 'true';

    var isRTL = wrapper.getAttribute('dir') === 'rtl';
    var currentPos = 0;

    function updateArrows() {
      var maxMove = list.scrollWidth - view.clientWidth;

      if (maxMove > 0) {
        btnPrev.style.display = currentPos < 0 ? 'flex' : 'none';
        btnNext.style.display = Math.abs(currentPos) < maxMove - 5 ? 'flex' : 'none';
      } else {
        btnPrev.style.display = 'none';
        btnNext.style.display = 'none';
      }
    }

    function move(direction) {
      var step    = 250;
      var maxMove = Math.max(0, list.scrollWidth - view.clientWidth);

      if (direction === 'next') currentPos -= step;
      else currentPos += step;

      if (currentPos > 0) currentPos = 0;
      if (Math.abs(currentPos) > maxMove) currentPos = -maxMove;

      list.style.transform = 'translateX(' + (isRTL ? -currentPos : currentPos) + 'px)';
      updateArrows();
    }

    btnNext.addEventListener('click', function () { move('next'); });
    btnPrev.addEventListener('click', function () { move('prev'); });

    var resizeTimer;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (window.innerWidth === lastWidth) return; /* ignore mobile URL-bar height changes */
        lastWidth = window.innerWidth;
        currentPos = 0;
        list.style.transform = 'translateX(0px)';
        updateArrows();
      }, 150);
    });

    updateArrows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewNav);
  } else {
    initNewNav();
  }
})();
